import React from "react";
import PageContainer from "../custom/Page";
import HeaderWithHelpDialog from "./components/Reports/Contract/byHierarchy/HeaderWithHelpDialog";
import ContractsByHierarchyContext from "./components/Reports/Contract/byHierarchy/ContractsByHierarchyContext";

import { CUSTOMER_ROUTES, HierarchyViewTypeEnum } from "../util";


const defaultParams = { hierarchyViewType: HierarchyViewTypeEnum.ALL };

const ReportContractByHierarchy = () => (
  <PageContainer full>
    <HeaderWithHelpDialog />

    <ContractsByHierarchyContext
      params={defaultParams}
      hierarchyViewType={defaultParams.hierarchyViewType}
      enableUserSelect
      customerRoutePrefix={CUSTOMER_ROUTES.MANAGER}
    />
  </PageContainer>
);

export default ReportContractByHierarchy;
